import UAParser from 'ua-parser-js';

export function isSafari() {
  const { name: browserName } = new UAParser(navigator.userAgent).getBrowser();

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return ['Safari', 'Mobile Safari'].includes(browserName);
}
